export interface IAppState {
    language: string
    serverTime: number | null
    error: boolean
    errorCode: number | undefined
    featureToggles: IFeatureToggles
    spinTheWheelOpen: boolean
    promoModalOpen: boolean
    appLoading: boolean
}

export interface IPromoPoints {
    value: boolean
    points: number
}

export interface ICanceledOrderPoints {
    enabled: boolean
    value: number
    email_cooldown_days: number
}

export interface IFeatureToggles {
    login_required: boolean
    coming_soon: boolean
    maintenance: boolean
    promo_points: IPromoPoints
    canceled_order_points: ICanceledOrderPoints
    bank_fee: number
}

export const initialFeatureToggles: IFeatureToggles = {
    login_required: false,
    coming_soon: false,
    maintenance: false,
    promo_points: {
        value: false,
        points: 50
    },
    canceled_order_points: {
        enabled: false,
        value: 0,
        email_cooldown_days: 7,
    },
    bank_fee: 0.017
}
